import styled, { css } from 'styled-components';
import { hBase, tab } from '@styles/breakpoints';
import { primaryLight } from '@styles/colors';

export const ModalContainerBtnClose = styled.button`
    position: absolute;
    top: 16px;
    right: 10px;
    background-color: transparent;
    outline: none;
    cursor: pointer;
    appearance: none;
    z-index: 9;

    ::before {
        display: inline-block;
        content: '';
        width: 20px;
        height: 20px;
        background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M15.0711 0.928917C15.4386 1.29647 15.4386 1.89239 15.0711 2.25994L9.33085 8.00016L15.0709 13.7402C15.4384 14.1078 15.4384 14.7037 15.0709 15.0712C14.7033 15.4388 14.1074 15.4388 13.7399 15.0712L7.99982 9.33118L2.25996 15.0711C1.8924 15.4386 1.29649 15.4386 0.928932 15.0711C0.56138 14.7035 0.56138 14.1076 0.928933 13.74L6.6688 8.00016L0.928757 2.26012C0.561205 1.89256 0.561204 1.29665 0.928757 0.929092C1.29631 0.56154 1.89223 0.561539 2.25978 0.929092L7.99983 6.66913L13.74 0.928917C14.1076 0.561365 14.7035 0.561365 15.0711 0.928917Z' fill='%23676E7B'/%3E%3C/svg%3E%0A");
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
    }

    :focus,
    :active,
    :hover {
        outline: none;
        ::before {
            background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M15.0711 0.928917C15.4386 1.29647 15.4386 1.89239 15.0711 2.25994L9.33085 8.00016L15.0709 13.7402C15.4384 14.1078 15.4384 14.7037 15.0709 15.0712C14.7033 15.4388 14.1074 15.4388 13.7399 15.0712L7.99982 9.33118L2.25996 15.0711C1.8924 15.4386 1.29649 15.4386 0.928932 15.0711C0.56138 14.7035 0.56138 14.1076 0.928933 13.74L6.6688 8.00016L0.928757 2.26012C0.561205 1.89256 0.561204 1.29665 0.928757 0.929092C1.29631 0.56154 1.89223 0.561539 2.25978 0.929092L7.99983 6.66913L13.74 0.928917C14.1076 0.561365 14.7035 0.561365 15.0711 0.928917Z' fill='%23FFFFFF'/%3E%3C/svg%3E%0A");
        }
    }
`;

export const ModalContainerContentStyled = styled.div`
    padding: 32px 24px 36px;
    margin: 36px auto 36px;
    border-radius: 8px;
    background: ${primaryLight};
    opacity: 0;
    transition: all 0.3s ease 0s;
    display: block;
    height: max-content;

    @media (min-width: ${tab}) {
        padding: 18px 36px 18px;
    }
`;

export const ModalContainerWrapperStyled = styled.div<{ visible: boolean }>`
    position: fixed;
    inset: 0px;
    width: 100%;
    height: 100%;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    mix-blend-mode: normal;
    overflow-y: auto;
    z-index: 999;
    transition: opacity 0.1s ease 0;

    > div {
        height: 100%;
        display: flex;
    }

    scrollbar-width: none;

    ::-webkit-scrollbar {
        display: none;
    }

    &.entering {
        opacity: 0;

        ${ModalContainerContentStyled} {
            opacity: 0;
            transform: translateY(-50px);
            transition-delay: 0.3s;
        }
    }

    &.entered {
        opacity: 1;

        ${ModalContainerContentStyled} {
            opacity: 1;
            transform: translateY(0px);
        }

        pointer-events: auto;
    }

    &.exiting {
        opacity: 1;
        transition-delay: 0.3s;

        ${ModalContainerContentStyled} {
            opacity: 1;
            transform: translateY(0px);
        }

        pointer-events: none;
    }

    &.exited {
        opacity: 0;

        ${ModalContainerContentStyled} {
            opacity: 0;
            transform: translateY(-50px);
        }
        pointer-events: none;
    }
`;

export const modalContainerStyles = css`
    @media (max-width: ${hBase}) {
        min-width: auto;
        min-height: auto;
        width: 80vw;
        height: auto;
        max-width: auto;
        max-height: auto;
    }
`;
